/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { NlpIntegrationGetLiveTopicsTopicByIdQueryResponse, NlpIntegrationGetLiveTopicsTopicByIdPathParams, NlpIntegrationGetLiveTopicsTopicById401, NlpIntegrationGetLiveTopicsTopicById403, NlpIntegrationGetLiveTopicsTopicById404 } from "../models/NlpIntegrationGetLiveTopicsTopicById";

export function getNlpIntegrationGetLiveTopicsTopicByIdUrl(slug: NlpIntegrationGetLiveTopicsTopicByIdPathParams["slug"], topicId: NlpIntegrationGetLiveTopicsTopicByIdPathParams["topicId"]) {
  const res = { method: 'GET', url: `/nlp-integration/v1/live-topics/${slug}/topics/${topicId}` as const }
  return res
}

/**
 * @description Fetch a single topic by id for the given channel slug.
 * @summary Get topic by id
 * {@link /nlp-integration/v1/live-topics/:slug/topics/:topicId}
 */
export async function nlpIntegrationGetLiveTopicsTopicById(slug: NlpIntegrationGetLiveTopicsTopicByIdPathParams["slug"], topicId: NlpIntegrationGetLiveTopicsTopicByIdPathParams["topicId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<NlpIntegrationGetLiveTopicsTopicByIdQueryResponse, ResponseErrorConfig<NlpIntegrationGetLiveTopicsTopicById401 | NlpIntegrationGetLiveTopicsTopicById403 | NlpIntegrationGetLiveTopicsTopicById404>, unknown>({ method : "GET", url : getNlpIntegrationGetLiveTopicsTopicByIdUrl(slug, topicId).url.toString(), ... requestConfig })
  return res.data
}